import { CompetenceScore, ExaminationCompetencyListQuery, TrialListQueryVariables } from "@generated/graphql";
import {
  aiGenerationPercentageFilter,
  candidateFullNameFilter,
  candidateNumericIdFilter,
  candidateScoreFilter,
  completedAtFilter,
  getStatusFilter,
} from "components/ExaminationList/config/filterConfig";
import { InputType } from "components/generators/inputsGenerator";
import { FilterField } from "layout/TableConstructor/types";

export type TrialFilter = NonNullable<TrialListQueryVariables["filter"]>;
export type CompetencyList = NonNullable<ExaminationCompetencyListQuery["examination"]["competencyMap"]>["competences"];
const filterConfig = (competencyList: CompetencyList): FilterField<TrialFilter>[] => {
  const dynamicFilters =
    competencyList?.map<FilterField<TrialFilter>>((c) => {
      return {
        label: `Компетенция ${c.title}`,
        name: `competenceScores.${c.id}`,
        type: InputType.TEXT,
        inputType: "number",
      };
    }) || [];
  return [
    // TODO: добавить после интеграции на бэке
    // trialNumericIdFilter,
    candidateNumericIdFilter,
    candidateFullNameFilter,
    completedAtFilter,
    getStatusFilter({ name: "status" }),
    candidateScoreFilter,
    aiGenerationPercentageFilter,
    {
      label: "динамические компетенции",
      name: "competenceScores",
      type: InputType.TEXT,
      isHidden: true,
      customFilter: (value): CompetenceScore[] | undefined => {
        if (typeof value === "object") {
          return Object.entries(value).reduce<CompetenceScore[]>((acc, [k, v]) => {
            const isValueExist = typeof v !== "undefined" && !Number.isNaN(v) && v !== "";
            if (isValueExist) {
              acc.push({
                competenceId: k,
                score: +v,
              });
            }
            return acc;
          }, []);
        }
        return undefined;
      },
    },
    ...dynamicFilters,
  ];
};

export default filterConfig;
